import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { quoteOne, quoteOneClearData, } from "../../../../store/generateQuote/actions";
import { formatToTwoDecimals } from "../../../../utils/getPrice";
export var useQuoteManagement = function (_a) {
    var quoteId = _a.quoteId, quoteResponse = _a.quoteResponse, paymentModeId = _a.paymentModeId, paymentModeName = _a.paymentModeName, userId = _a.userId, setBodyPatchQuote = _a.setBodyPatchQuote, setTriggerPatchQuote = _a.setTriggerPatchQuote, setPrice = _a.setPrice, setCurrencySymbol = _a.setCurrencySymbol, setShowAlert = _a.setShowAlert, setEnableNextBtn = _a.setEnableNextBtn, setQuoteResponse = _a.setQuoteResponse;
    var dispatch = useDispatch();
    var _b = useSelector(function (state) { return ({
        responseOneQuote: state.Quote.responseOneQuote,
        errorOneQuote: state.Quote.errorOneQuote,
        loadingOneQuote: state.Quote.loadingOneQuote,
    }); }), responseOneQuote = _b.responseOneQuote, errorOneQuote = _b.errorOneQuote, loadingOneQuote = _b.loadingOneQuote;
    var callQuoteOne = function (quoteId) {
        dispatch(quoteOne({
            id: quoteId,
            fullBody: true,
        }));
    };
    useEffect(function () {
        var _a;
        if (responseOneQuote && (responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data)) {
            if (!quoteResponse) {
                var quotePatch = {
                    planId: responseOneQuote.data.planId.id,
                    coverTypeId: (_a = responseOneQuote.data.planId.coverTypes) === null || _a === void 0 ? void 0 : _a[0].id,
                    campaignId: responseOneQuote.data.campaignId.id,
                    catalogStatusQuote: responseOneQuote.data.catalogStatusQuote.id,
                    branchId: responseOneQuote.data.branch,
                    userId: userId || "",
                    catalogPaymentMode: paymentModeId,
                };
                setBodyPatchQuote(quotePatch);
                if (paymentModeId) {
                    setTriggerPatchQuote(true);
                }
                dispatch(quoteOneClearData());
            }
            else if (quoteResponse) {
                var numericValue = parseFloat(responseOneQuote.data.lastPrice.amount
                    ? responseOneQuote.data.lastPrice.amount
                    : "0.00");
                if (paymentModeName === "MON") {
                    setPrice(responseOneQuote.data.lastPrice.amount
                        ? formatToTwoDecimals(numericValue.toString())
                        : "0.00");
                }
                else {
                    setPrice(responseOneQuote.data.lastPrice.amount
                        ? formatToTwoDecimals(responseOneQuote.data.lastPrice.amount)
                        : "0.00");
                }
                if (responseOneQuote.data.lastPrice.amount === "0.00") {
                    setShowAlert(true);
                    setEnableNextBtn(false);
                }
                else {
                    setShowAlert(false);
                }
                setCurrencySymbol(responseOneQuote.data.lastPrice.currencySymbol);
                setQuoteResponse(false);
                dispatch(quoteOneClearData());
            }
        }
    }, [responseOneQuote, quoteResponse]);
    return {
        responseOneQuote: responseOneQuote,
        errorOneQuote: errorOneQuote,
        loadingOneQuote: loadingOneQuote,
        callQuoteOne: callQuoteOne,
    };
};
